<template>
<div class="chapter">
<div class="inner_page">
<p class="normal1"><i>People are strange<br/>when you’re a stranger …</i></p>
<p class="right2"><span><i>—Jim Morrison</i></span></p>
<p class="normal-c"><i>Under normal circumstances, sexual desires become stabilized as soon as they meet adequate satisfaction.… Freud describes a case in which the husband and wife had reached an exceptionally high level of perversion before they met (they had practiced every perversion in the book); it was a completely happy marriage, which ended only when the husband was arrested for the murder of a rich American woman.</i></p>
<p class="right3"><span>—<i>Colin Wilson</i>, Order of Assassins</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?6630723a